import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { classSummaryModel } from '../models/classSummaryModel';

@Injectable({
  providedIn: 'root'
})
export class ClassSummaryService {

  constructor(private _http: HttpClient) { }

  getClassSummary(classSummaryModel:classSummaryModel): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'CustomerWiseInvoices/PostSummaryReport', classSummaryModel);
    
  }
}
